import { render, staticRenderFns } from "./comboAssets.vue?vue&type=template&id=cc5397c8&scoped=true"
import script from "./comboAssets.vue?vue&type=script&lang=js"
export * from "./comboAssets.vue?vue&type=script&lang=js"
import style0 from "./comboAssets.vue?vue&type=style&index=0&id=cc5397c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5397c8",
  null
  
)

export default component.exports